import React, {useEffect} from 'react';
import {useHistory} from 'react-router-dom'
import {Button,} from '@mui/material';

function SpacecastError(props) {
  const history = useHistory();

  useEffect(() => {
    document.getElementById("spacecast").innerHTML = ""
  }, []);

  return (
    <div style={{width:"100%"}}>
      <div style={{margin:"2rem auto", width:"fit-content"}}>
        Something went wrong.
        <Button style={{margin:"0 2rem"}} variant="contained" onClick={() => history.goBack()} color="primary">Go Back</Button>
      </div>
    </div>

  )
}
export default SpacecastError;